import { object, string, number } from 'yup';
import NewPanContainer from '../NewPanContainer/NewPanContainer';
import { basicDetails, submitreference } from '../../../common/constants/api';
import NewBasicDetails from '../../../components/Dashboard-res/NewBasicDetails/NewBasicDetails';
import BussinessType from '../../../components/Dashboard-res/BusinessType/businessType';
import ProfessionType from '../../../components/Dashboard-res/Profession/Profession';
import Aadhar from '../Aadhar/Aadhar';
import NewAddressProof from '../../PartnerKyc/NewAddressProof/NewAddressProof';
import Selfie from '../../PartnerKyc/Selfie/Selfie';
import BankDetailsContainer from '../../PartnerKyc/BankDetailsContainer/BankDetails';
import Reference from '../../PartnerKyc/Reference/Reference';
import KYCHighlight from '../../../components/KYCHighlightScreen/KYCHighlight';
import PartnerProfile from '../../PartnerKyc/ProfilePage/ProfilePage';
import { currentYear } from '../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import { navigate } from 'gatsby';

let Steps = [
  {
    id: 'basicDetails',
    component: NewBasicDetails,

    initialValues: {
      Name: '',
      lastName: '',
      date: {
        value: '',
        label: 'Date'
      },
      month: {
        value: '',
        label: 'Month'
      },
      year: {
        value: '',
        label: ''
      },

      email: '',
      mobile: '',
      pincode: '',
      city: '',
      state: '',
      emailOtp: ''
    },
    validationSchema: object().shape({
      Name: string()
        .min(1, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
      lastName: string()
        .min(1, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),

      date: object().shape({
        value: string().required('Required')
      }),
      month: object().shape({
        value: string().required('Required')
      }),
      year: object().shape({
        value: string().required('Required')
      }),

      email: string()
        .email('Please enter email address')
        .max(50, 'Email address is Too Long!')
        .required('Required')
        .matches(
          /^([a-z 0-9\.-_]+)@([a-z 0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/,
          'invalid type'
        ),
      mobile: string()
        .required('Required')
        .max(10)
        .matches(/([6-9]\d{9})/, 'Mobile should be 10 digit number'),
      // DOB: date().required("Required"),
      pincode: string()
        .required('Required')
        .max(6)
        .matches(/\d{6}/, 'Pincode should be 6 digit number')
    }),
    enableReinitialize: true,
    onAction: async (sectionValues, formValues) => {
      basicDetails({
        name: {
          firstName: sectionValues.Name,
          lastName: sectionValues.lastName
        },
        phone: sectionValues.mobile,
        addressResidence: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          pinCode: sectionValues.pincode
        },
        email: sectionValues.email,
        dob: new Date(
          `${sectionValues.year.value}-${sectionValues.month.value}-${sectionValues.date.value}`
        )
      })
        .then(data => {
          console.log('response onClick NewBasicDetails:', data);
          // navigate('/app/dashboard');
        })

        .catch(err => {
          console.log('error status:', err.message);
          if (err.message == 'Network Error') {
            console.log('network_Error!');
          } else {
            console.log(err.status);
          }
        });
    }
  },
  {
    id: 'businessType',
    component: BussinessType
  },
  {
    id: 'professionType',
    component: ProfessionType
  },
  {
    id: 'pan',
    component: NewPanContainer,
    enableReinitialize: true,
    initialValues: {
      name: '',
      pan_no: '',
      father_name: '',
      date: {
        value: '',
        label: 'Date'
      },
      month: {
        value: '',
        label: 'Month'
      },
      year: {
        value: String(currentYear - 18),
        label: String(currentYear - 18)
      },
      shouldSubmit: false
    },
    validationSchema: object().shape({
      name: string()
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required'),
      pan_no: string()
        .matches(
          '^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$',
          'PAN Number invalid format '
        )
        .required('Required'),

      father_name: string()
        .min(1, 'Too Short Name!')
        .max(50, 'Too Long Name!')
        .required('Required'),
      date: object().shape({
        value: string().required('Required')
      }),
      month: object().shape({
        value: string().required('Required')
      }),
      year: object().shape({
        value: string().required('Required')
      })
    }),
    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'aadhar',
    component: Aadhar,
    initialValues: {
      full_name: '',
      aadhar_no: '',
      address: '',
      date: {
        value: '',
        label: 'Date'
      },
      month: {
        value: '',
        label: 'Month'
      },
      year: {
        value: '',
        label: 'Year'
      },
      male: true,
      female: false
    },
    // validationSchema: object().shape({
    //   full_name: string()
    //     .min(1, 'Too Short Name!')
    //     .max(70, 'Too Long Name!')
    //     .required('Required'),
    //   aadhar_no: string()
    //     .matches('^[0-9]{12}?$', 'Aadhar Number Should be  12 digit Number')

    //     .required('Required'),

    //   address: string()
    //     .min(1, 'Too Short Name!')
    //     .required('Required'),
    //   date: object().shape({
    //     value: string().required('Required')
    //   }),
    //   month: object().shape({
    //     value: string().required('Required')
    //   }),
    //   year: object().shape({
    //     value: string().required('Required')
    //   })
    // }),
    actionLabel: 'skip and continue',
    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'addressProof',
    component: NewAddressProof
  },
  {
    id: 'selfie',
    component: Selfie
  },
  {
    id: 'bankDetailsContainer',
    component: BankDetailsContainer,
    enableReinitialize: true,

    initialValues: {
      kyc_account_holder_name: '',
      kyc_acc_no: '',
      kyc_ifsc_code: '',
      kyc_bank_name: '',
      kyc_bank_address: ''
    },
    validationSchema: object().shape({
      kyc_account_holder_name: string()
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required'),
      kyc_ifsc_code: string()
        .min(11, 'Must be equal to 11 digit')
        .max(11, 'Must be equal to 11 digit')
        .required('Required'),
      kyc_acc_no: string()
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required'),

      kyc_bank_name: string()
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required'),
      kyc_bank_address: string()
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required')
    }),
    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'reference',
    component: Reference,
    enableReinitialize: true,
    initialValues: {
      ref_1_name: '',
      ref_2_name: '',
      ref_1_number: '',
      ref_2_number: '',
      ref_1_company: '',
      ref_2_company: '',
      ref_1_designation: '',
      ref_2_designation: ''
    },
    validationSchema: object().shape({
      ref_1_name: string()
        .min(1, 'Too Short Name!')
        .max(50, 'Too Long Name!')
        .required('Required'),
      ref_1_number: string()
        .required('Required')
        .matches('^[0-9]{10}?$', 'Mobile Number Should be  10 digit Number'),
      ref_1_company: string()
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required'),
      ref_1_designation: string()
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required'),
      ref_2_name: string()
        .min(1, 'Too Short Name!')
        .max(50, 'Too Long Name!')
        .required('Required'),
      ref_2_number: string()
        .required('Required')
        .matches('^[0-9 ]{10}?$', 'Mobile Number Should be  10 digit Number'),
      ref_2_company: string()
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required'),
      ref_2_designation: string()
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required')
    }),
    onAction: (sectionValues, formValues) => {
      let body = [
        {
          name: sectionValues.ref_1_name,
          number: sectionValues.ref_1_number,
          company: sectionValues.ref_1_company,
          designaton: sectionValues.ref_1_designation
        },
        {
          name: sectionValues.ref_2_name,
          number: sectionValues.ref_2_number,
          company: sectionValues.ref_2_company,
          designaton: sectionValues.ref_2_designation
        }
      ];
      submitreference(JSON.stringify(body));
    }
  },
  {
    id: 'kycHighlight',
    component: KYCHighlight,
    onAction: (sectionValues, formValues) => {
      // navigate('/app/myprofile/');
    }
  },
  {
    id: 'partnerProfile',
    component: PartnerProfile
  }
];
export default Steps;
